import React from "react";
import { fmtEuro } from "@/lib/format";
import { KpiCard } from "@/components/dashboard/Kpi";

const costs = (sec) => (sec ? sec.dept.actual + sec.undistributed.actual + sec.fixed.actual : 0);
const ratio = (c, r) => (r ? (c / r) * 100 : 0);
const pct = (v) => `${(v || 0).toFixed(1)}%`;
const exSum = (x) => Object.values(x || {}).reduce((s, v) => s + v, 0);

export const CostPanel = ({ cur, ly, stats, month }) => {
  const cM = costs(cur?.sections), cY = costs(cur?.ytd?.sections);
  const lM = costs(ly?.sections), lY = costs(ly?.ytd?.sections);
  const rM = cur?.sections?.revenue.actual || 0, rY = cur?.ytd?.sections?.revenue.actual || 0;
  const lrM = ly?.sections?.revenue.actual || 0, lrY = ly?.ytd?.sections?.revenue.actual || 0;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        <KpiCard testid="kpi-cost-month" label={`Λειτουργικό κόστος ${month}`} value={cM} ly={lM} invert />
        <KpiCard testid="kpi-cost-ytd" label="Λειτουργικό κόστος YTD" value={cY} ly={lY} invert />
        <KpiCard testid="kpi-net-ytd" label="Λειτουργικό αποτέλεσμα YTD" value={rY - cY} ly={lrY - lY} sub={`Μήνας ${fmtEuro(rM - cM)}`} />
        <KpiCard testid="kpi-cost-ratio" label="Κόστος / έσοδα YTD" value={ratio(cY, rY)} ly={ratio(lY, lrY)} fmt={pct} invert sub={`Μήνας ${pct(ratio(cM, rM))}`} />
      </div>
      <div className="rounded-xl border border-dashed border-[#B9AE9A] bg-[#F7F5F1] px-4 py-3 flex flex-wrap items-center justify-between gap-2" data-testid="dash-capex">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">Εκτός λειτουργικού κόστους</div>
          <div className="text-xs text-[#6F6A60]">Επενδύσεις / κατασκευές / εξοπλισμός, συντήρηση POM (6400), owner & φόρος εισοδήματος</div>
        </div>
        <div className="flex gap-6 text-sm tabular">
          <span>{month}: <strong className="text-[#45423C]" data-testid="dash-capex-month">{fmtEuro(exSum(cur?.excluded))}</strong></span>
          <span>YTD: <strong className="text-[#45423C]" data-testid="dash-capex-ytd">{fmtEuro(exSum(cur?.ytd?.excluded))}</strong></span>
          <span className="text-[#B9AE9A]">πέρσι YTD {fmtEuro(exSum(ly?.ytd?.excluded))}</span>
        </div>
      </div>
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm" data-testid="dash-payroll">
          {[["Ετήσια μισθοδοσία", fmtEuro(stats.annual_payroll)], ["Υπάλληλοι", stats.employee_count],
            ["Κόστος TAF", fmtEuro(stats.taf_cost)], ["Κόστος TRIBE", fmtEuro(stats.tribe_cost)]].map(([l, v]) => (
            <div key={l} className="rounded-xl bg-[#F7F5F1] px-4 py-3">
              <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">{l}</div>
              <div className="font-serif text-lg text-[#45423C] tabular">{v}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
